import { VariantProps } from 'tailwind-variants';

import { IconKitMarker } from '@/icon/kit/Marker';

import { styles } from './UiKitCounter.styles';

type Variants = VariantProps<typeof styles>;
type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface UiKitCounterProps {
  className?: string;
  prefix?: 'marker';
  counter?: number;
  size?: Variants['size'];
  onClick?: NativeElement['onClick'];
  noLimit?: boolean;
}

export function UiKitCounter({
  className,
  prefix,
  counter = 0,
  size,
  noLimit = false,
  ...props
}: UiKitCounterProps) {
  if (counter < 1 && prefix === undefined) return null;

  const slots = styles({ size });

  const prefixIcon = {
    marker: <IconKitMarker className="size-1.75" />
  };

  return (
    <div
      className={slots.base({ className })}
      {...props}
    >
      {prefix ? prefixIcon[prefix] || null : null}
      {counter > 0 && (counter < 100 || noLimit ? counter : '99+')}
    </div>
  );
}
